import {css, cva, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

interface IProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

export const PropertyListLoader = (props: IProps) => {
    const {useTopOffset, boxShadowCover, backgroundColor} = props;

    const normalizedUseTopOffset = !!useTopOffset;
    const normalizedBoxShadowCover = !!boxShadowCover;

    return (
        <div
            className={cx(
                loaderWrapper({
                    useTopOffset: normalizedUseTopOffset,
                    boxShadowCover: normalizedBoxShadowCover
                }),
                css({backgroundColor: backgroundColor || "var(--colors-white)"})
            )}
        >
            <Loader />
        </div>
    );
};

export const loaderWrapper = cva({
    base: {
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 30
    },

    variants: {
        useTopOffset: {
            true: {
                top: "54px",
                height: "calc(100% - 64px)",

                xs: {
                    top: "64px"
                }
            },
            false: {}
        },

        boxShadowCover: {
            true: {
                top: "-15px",
                left: "-20px",
                width: "calc(100% + 40px)",
                height: "calc(100% + 17px)"
            },
            false: {
                left: "0",
                width: "100%"
            }
        }
    },

    compoundVariants: [
        {
            useTopOffset: false,
            boxShadowCover: false,
            css: {
                top: "0",
                height: "100%"
            }
        }
    ]
});
import {css, cva, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

interface IProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

export const PropertyListLoader = (props: IProps) => {
    const {useTopOffset, boxShadowCover, backgroundColor} = props;

    const normalizedUseTopOffset = !!useTopOffset;
    const normalizedBoxShadowCover = !!boxShadowCover;

    return (
        <div
            className={cx(
                loaderWrapper({
                    useTopOffset: normalizedUseTopOffset,
                    boxShadowCover: normalizedBoxShadowCover
                }),
                css({backgroundColor: backgroundColor || "var(--colors-white)"})
            )}
        >
            <Loader />
        </div>
    );
};

export const loaderWrapper = cva({
    base: {
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 30
    },

    variants: {
        useTopOffset: {
            true: {
                top: "54px",
                height: "calc(100% - 64px)",

                xs: {
                    top: "64px"
                }
            },
            false: {}
        },

        boxShadowCover: {
            true: {
                top: "-15px",
                left: "-20px",
                width: "calc(100% + 40px)",
                height: "calc(100% + 17px)"
            },
            false: {
                left: "0",
                width: "100%"
            }
        }
    },

    compoundVariants: [
        {
            useTopOffset: false,
            boxShadowCover: false,
            css: {
                top: "0",
                height: "100%"
            }
        }
    ]
});
